import { render } from "./WeeklyPlanSidebar.vue?vue&type=template&id=38b378d4&scoped=true"
import script from "./WeeklyPlanSidebar.vue?vue&type=script&lang=js"
export * from "./WeeklyPlanSidebar.vue?vue&type=script&lang=js"

import "./WeeklyPlanSidebar.vue?vue&type=style&index=0&id=38b378d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b378d4"],['__file',"src/layouts/teacher/WeeklyPlanSidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38b378d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38b378d4', __exports__)) {
    api.reload('38b378d4', __exports__)
  }
  
  module.hot.accept("./WeeklyPlanSidebar.vue?vue&type=template&id=38b378d4&scoped=true", () => {
    api.rerender('38b378d4', render)
  })

}


export default __exports__